{
  "schemaVersion": 1,
  "applicationName": "Sonox IM Web Client",
  "applicationType": "web",
  "appId": "imapp_025b4cb83f934cc3a76eedc77e4dc403",
  "clientId": "imapp_025b4cb83f934cc3a76eedc77e4dc403",
  "tenantId": "imt_025b4cb83f934cc3a76eedc77e4dc403",
  "oidcIssuer": "https://sso.smartflx.com",
  "apiBaseUrl": "https://api.im.smartflx.com",
  "webSocketUrl": "wss://ws.im.smartflx.com/v1/connect",
  "primaryOrigin": "https://chat.smartflx.com",
  "redirectUris": [
    "https://chat.smartflx.com/callback",
    "https://sonox-im-client.pages.dev/callback",
    "http://localhost:5173/callback",
    "http://localhost:4173/callback"
  ],
  "allowedOrigins": [
    "https://chat.smartflx.com",
    "https://sonox-im-client.pages.dev",
    "http://localhost:5173",
    "http://localhost:4173"
  ],
  "registeredAt": "2026-08-13T04:34:59Z"
}
